import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Gift, Copy, Crown } from "lucide-react";

export const ReferralCard = ({ role }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/me/referrals").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  const link = `${window.location.origin}/auth?tab=register&ref=${data.referral_code}`;
  const copy = () => {
    navigator.clipboard.writeText(link);
    toast.success("Link de convite copiado");
  };
  const premium = data.premium_until && new Date(data.premium_until) > new Date();
  const progress = data.referral_count % 3;

  return (
    <div data-testid="referral-card" className="bg-slate-900 rounded-2xl p-6">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-amber-400 mb-2 flex items-center gap-1.5">
        <Gift className="w-3.5 h-3.5" /> Programa de convites
      </p>
      {role === "candidate" ? (
        <>
          <p className="text-sm text-slate-300">
            Convida 3 amigos e ganha <b className="text-white">30 dias de IA Premium</b> — análises de CV e preenchimento de perfil ilimitados.
          </p>
          <div className="flex items-center gap-2 mt-3">
            {[0, 1, 2].map((i) => (
              <div key={i} className={`h-2 flex-1 rounded-full ${i < progress ? "bg-amber-400" : "bg-white/15"}`} />
            ))}
            <span data-testid="referral-progress" className="text-xs text-slate-400">{data.referral_count} convite(s)</span>
          </div>
          {premium && (
            <Badge data-testid="referral-premium-badge" className="bg-amber-400 text-slate-950 hover:bg-amber-400 mt-3">
              <Crown className="w-3 h-3 mr-1" /> Premium IA até {new Date(data.premium_until).toLocaleDateString("pt-PT")}
            </Badge>
          )}
        </>
      ) : (
        <>
          <p className="text-sm text-slate-300">
            Por cada empresa convidada que faça a primeira compra, recebes <b className="text-white">1 crédito DESTAQUE</b> (valor 45€).
          </p>
          <p data-testid="referral-b2b-stats" className="text-xs text-slate-400 mt-2">
            {data.referral_count} empresa(s) convidada(s) · {data.rewards?.length || 0} crédito(s) ganho(s)
          </p>
        </>
      )}
      <div className="flex items-center gap-2 mt-4">
        <code data-testid="referral-link" className="text-xs text-slate-300 bg-white/10 rounded-lg px-3 py-2 flex-1 truncate">{link}</code>
        <Button data-testid="referral-copy-btn" size="sm" className="rounded-full bg-amber-400 text-slate-950 hover:bg-amber-300" onClick={copy}>
          <Copy className="w-3.5 h-3.5 mr-1" /> Copiar
        </Button>
      </div>
    </div>
  );
};
